import React from 'react';
import { default as __ } from '../../utils';

function CourtSide({
  cb = __.noop(),
  variant,
  shades = ['var(--black)', 'var(--ultrapurple)'],
  transforms = null,
}) {
  let transformedStyles = {
    transform: transforms ? transforms : '',
  };

  return (
    <svg
      viewBox="0 0 240 144"
      width="240"
      height="144"
      style={transformedStyles}
      onClick={() => cb(variant)}
    >
      <rect
        x="0"
        y="0"
        width="120"
        height="144"
        fill={variant === 'left' ? shades[1] : shades[0]}
      />
      <rect
        x="120"
        y="0"
        width="120"
        height="144"
        fill={variant === 'left' ? shades[0] : shades[1]}
      />
    </svg>
  );
}

export default CourtSide;
